export function sde1FeatureActive (feature) {
  return (process.env.SDE1_ACTIVE_FEATURES || '')
    .split(',')
    .map(value => value.trim())
    .includes(feature)
}

export function sde1Active () {
  return sde1FeatureActive('db') && sde1FeatureActive('http')
}



// WEBPACK FOOTER //
// ./src/sunset-helper.js